function getIcoonDataUri(icoonBase64) {
    const mimeType = icoonBase64.startsWith("PHN2") || icoonBase64.startsWith("PD94") ? "image/svg+xml" :
        icoonBase64.startsWith("/9j/") ? "image/jpeg" : "image/png";
    return `data:${mimeType};base64,${icoonBase64}`;
}

export { getIcoonDataUri };
